import { render, staticRenderFns } from "./SelfOccupationSkillsRatingTab.vue?vue&type=template&id=065628a7"
import script from "./SelfOccupationSkillsRatingTab.vue?vue&type=script&lang=js"
export * from "./SelfOccupationSkillsRatingTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('065628a7')) {
      api.createRecord('065628a7', component.options)
    } else {
      api.reload('065628a7', component.options)
    }
    module.hot.accept("./SelfOccupationSkillsRatingTab.vue?vue&type=template&id=065628a7", function () {
      api.rerender('065628a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/employee/rating/partials/tabs/SelfOccupationSkillsRatingTab.vue"
export default component.exports